import React, { useState, useEffect, useRef } from 'react';
import { ReactSortable } from 'react-sortablejs';
import { Link, Switch, Route, useHistory, useRouteMatch, useLocation } from 'react-router-dom';
import { css, StyleSheet } from 'aphrodite/no-important';
import isMobilePhone from 'validator/lib/isMobilePhone';
import { Cropper } from 'react-cropper';
import {
  PopupMenu,
  TabsContainer,
  TabItem,
  Drawer,
  Button,
  TextInput,
  TextInputWithLabel,
  FileUploader,
  Toast,
  Loader
} from 'quantux-ui';
import WarningDialog from '../warning-dialog';
import PracticeUserCard from '../my-practices/practice-user-card';
import About from '../about';
import Contact from '../contact';
import { BASE_URL } from '../../utils';
import { blue, gray, salmon } from '../../theme';

const AboutFacility = (props) => {
  const {
    userName = '',
    displayName = '',
    avatarImageUrl = 'https://quantumtrader.s3.amazonaws.com/defaultAvatar.svg',
    bannerImageUrl = 'https://quantumtrader.s3.amazonaws.com/defaultBanner.svg',
    profileDescription = '',
    email = '',
    phone = '',
    fax = '',
    mailingAddress = {},
    facilityName = '',
    website = '',
    npi = '',
    users = []
  } = props.facilityData;

  const {
    streetAddress1 = '',
    suite = '',
    city = '',
    state = '',
    zip = ''
  } = mailingAddress;

  console.log('props.facilityData');
  console.log(props.facilityData.users);

  const isFirstRender = useRef(true);
  const locContainerRef = useRef();
  //
  const [isEllipisiMenuOpen, toggleEllipsisMenu] = useState(false);
  // Edit profile drawer variables
  const [isEditProfileDrawerOpen, toggleEditProfileDrawer] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [canSaveFacility, setCanSaveFacility] = useState(false);
  const [facilityDisplayName, setFacilityDisplayName] = useState(displayName);
  const [isFacilityDisplayNameValid, checkFacilityDisplayNameValidity] = useState(true);
  const [isFacilityDisplayNamePristine, setFacilityDisplayNamePristineState] = useState(true);
  const [facilityUserName, setFacilityUserName] = useState(userName);
  const [isFacilityUserNameValid, checkFacilityUserNameValidity] = useState(true);
  const [isFacilityUserNamePristine, setFacilityUserNamePristineState] = useState(true);
  const [isDuplicateUserName, setIsDuplicateUserName] = useState(false);
  const [organization, setOrganization] = useState(facilityName);
  const [facilityStreetAddress, setFacilityStreetAddress] = useState(streetAddress1);
  const [facilitySuite, setFacilitySuite] = useState(suite);
  const [facilityCity, setFacilityCity] = useState(city);
  const [facilityState, setFacilityState] = useState(state);
  const [facilityZip, setFacilityZip] = useState(zip);
  const [facilityPhone, setFacilityPhone] = useState(phone);
  const [isFacilityPhoneValid, checkFacilityPhoneValidity] = useState(false);
  const [isFacilityPhonePristine, setFacilityPhonePristineState] = useState(true);
  const [facilityFax, setFacilityFax] = useState(fax);
  const [facilityWebsite, setFacilityWebsite] = useState(website);
  const [facilityProfileDescription, setFacilityProfileDescription] = useState(profileDescription);
  // Banner cropper drawer
  const [isBannerCropperDrawerOpen, toggleBannerCropperDrawer] = useState(false);
  const [facilityBannerImageUrl, setFacilityBannerImageUrl] = useState(bannerImageUrl);
  const [showBannerCropper, setShowBannerCropper] = useState(false);
  const [isBannerUploading, setIsBannerUploading] = useState(false);
  // Avatar cropper drawer
  const [isAvatarCropperDrawerOpen, toggleAvatarCropperDrawer] = useState(false);
  const [facilityAvatarImageUrl, setFacilityAvatarImageUrl] = useState(avatarImageUrl);
  const [showAvatarCropper, setShowAvatarCropper] = useState(false);
  const [isAvatarUploading, setIsAvatarUploading] = useState(false);
  //
  const [facilityUser, setFacilityUser] = useState('');
  const [showFacilityUserSearchMenu, toggleFacilityUserSearchMenu] = useState(false);
  const [canAddFacilityUser, setCanAddFacilityUser] = useState(false);
  const [facilityUsersSearchResults, setFacilityUsersSearchResults] = useState([]);
  const [facilityUserNpi, setFacilityUserNpi] = useState('');
  const [facilityUserId, setFacilityUserId] = useState('');
  const [facilityUserAvatarImageUrl, setFacilityUserAvatarImageUrl] = useState('');
  const [facilityUsers, setFacilityUsers] = useState(users);
  // -- Facility locations
  const [showManageLocationsDrawer, setShowManageLocationsDrawer] = useState(false);
  const [newProcedureLocation, setNewProcedureLocation] = useState('');
  const [locFilter, setLocFilter] = useState('');
  const [procedureLocations, setProcedureLocations] = useState(props.facilityData.locations || []);
  // --
  const [showDuplicateLocationMsg, setShowDuplicateLocationMsg] = useState(false);
  // --
  const [showLocationDeleteWarning, setShowLocationDeleteWarning] = useState(false);
  // --
  const [locationToDelete, setLocationToDelete] = useState('');
  // --
  const [showSaveWarningMessage, setShowSaveWarningMessage] = useState(false);
  const [isLocDataUpdated, setIsLocDataUpdated] = useState(false);

  // Refs
  const popupRef = useRef();
  const tabsContainer = useRef();
  const editProfileTabsContainer = useRef();
  const drawerBannerRef = useRef();
  const drawerAvatarRef = useRef();
  const facilityUsersRef = useRef();
  const bannerCropperRef = useRef();
  const bannerFileInputRef = useRef();
  const avatarCropperRef = useRef();
  const avatarFileInputRef = useRef();

  // Local variables
  const history = useHistory();
  const location = useLocation();
  const { pathname } = location;
  const { path, url } = useRouteMatch();
  const tabsTextStyles = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  };

  // -------------------------------- Network requests ---------------------------------
  function searchFacilityUsers() {
    const url = new URL(`${BASE_URL}/users/searchMedPros`);
    const params = { searchTerm: facilityUser };
    url.search = new URLSearchParams(params).toString();
    fetch(url)
      .then(res => res.text())
      .then((result) => {
        const data = JSON.parse(result);
        setFacilityUsersSearchResults(data.users ? data.users : []);
      })
      .catch(error => console.log('error', error));
  };

  // -------------------------------- useEffect hooks ---------------------------------
  // Search facility users
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    const ddF = setTimeout(() => {
      if (facilityUser.length > 0) {
        searchFacilityUsers();
      }
    }, 300);
    return () => clearTimeout(ddF);
  }, [facilityUser]);

  // Facility username duplicate check
  useEffect(() => {
    if (props.facilityData.userName === facilityUserName) {
      checkFacilityUserNameValidity(true);
      setFacilityUserNamePristineState(true);
      setIsDuplicateUserName(false);
      return;
    }
    if (facilityUserName.length >= 2 && facilityUserName.length <= 20 && facilityUserName.indexOf(' ') < 0) {
      const url = new URL(`${BASE_URL}/facility/isFacilityUserNameExists`);
      const params = { userName: facilityUserName };
      url.search = new URLSearchParams(params).toString();
      fetch(url)
        .then(res => res.text())
        .then((result) => {
          const data = JSON.parse(result);
          console.log(data);
          setIsDuplicateUserName(data.isDuplicate);
        })
        .catch(error => console.log('error', error));
    }
  }, [facilityUserName]);

  // Can add facility flag check
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    const value =
      facilityDisplayName.length >= 2 && facilityDisplayName.length <= 40 &&
      facilityUserName.length >= 2 && facilityUserName.length <= 20 && facilityUserName.indexOf(' ') < 0;

    console.log(`facilityDisplayName =  ${facilityDisplayName.length >= 2 && facilityDisplayName.length <= 40}`);
    console.log(`facilityUserName = ${facilityUserName.length >= 2 && facilityUserName.length <= 20 && facilityUserName.indexOf(' ') < 0}`);
    console.log(`facilityStreetAddress = ${facilityStreetAddress.length > 5}`);
    console.log(`facilityCity = ${facilityCity.length >= 2}`);
    console.log(`facilityState = ${facilityState.length === 2}`);
    console.log(`facilityZip = ${facilityZip.length >= 5}`);
    console.log(`isFacilityPhoneValid = ${isMobilePhone(facilityPhone, 'en-US')}`);
    console.log(`setCanSaveFacility = ${value}`);
    setCanSaveFacility(value);
  }, [
    facilityDisplayName,
    facilityUserName,
    facilityStreetAddress,
    facilitySuite,
    facilityCity,
    facilityState,
    facilityZip,
    facilityPhone,
    facilityProfileDescription,
    facilityUsers
  ]);

  // ------------------------------------- Styles -------------------------------------
  const styles = StyleSheet.create({
    profileBanner: {
      borderBottom: '1px solid transparent'
    },
    profileBannerImg: {
      width: '100%',
      height: 'auto',
      maxHeight: '220px'
    },
    bigUserCardContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      borderBottom: '1px solid transparent'
    },
    userCard: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '80px',
      height: '80px',
      // background: '#0080FF',
      borderRadius: '4px'
    },
    userCardIcon: {
      color: 'white',
      fontSize: '70px'
    },
    userCardAvatarImg: {
      width: 'auto',
      height: '80px',
      maxHeight: '80px',
      borderRadius: '4px'
    },
    userCardDisplayName: {
      color: blue[500]
    },
    userCardEllipsisMenuBtn: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#60A0E0',
      height: '24px',
      width: '24px',
      borderRadius: '50%',
      color: '#001824',
      position: 'relative'
    },
    popupMenuContainer: {
      background: '#083050',
      width: '150px',
      boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.5)'
    },
    popupMenuItem: {
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      color: '#5080B0'
    },
    menuItemIconContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '40px',
      width: '40px'
    },
    menuItemIcon: {
      fontSize: '20px'
    },
    drawerContainer: {
      // background: gray[800],
      background: gray[600],
      color: gray[300],
      height: '100%',
      position: 'relative',
      display: 'flex',
      flexFlow: 'column'
    },
    drawerHeader: {
      height: '40px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 8px',
      fontWeight: 'bold',
      borderBottom: '1px solid black',
      flexShrink: '0'
    },
    drawerHeaderCloseIcon: {
      color: gray[300],
      ':hover': {
        color: salmon[500]
      }
    },
    drawerBanner: {
      position: 'relative',
      padding: '8px',
      flexShrink: '0'
    },
    drawerBannerImg: {
      width: '100%',
      height: 'auto'
    },
    drawerBannerCameraIcon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: gray[500],
      color: 'white',
      position: 'absolute',
      right: '0',
      bottom: '8px',
      fontSize: '11px',
      width: '24px',
      height: '24px',
      cursor: 'pointer',
      borderRadius: '50%'
    },
    drawerContentArea: {
      color: gray[300],
      flexGrow: '1'
    },
    drawerUserCardAvatar: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '80px',
      height: '80px',
      background: blue[500],
      color: 'white',
      borderRadius: '4px',
      position: 'relative'
    },
    drawerUserCardAvatarImg: {
      width: 'auto',
      height: '80px',
      maxHeight: '80px'
    },
    drawerAvatarCamera: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: gray[500],
      color: 'white',
      position: 'absolute',
      left: '-3px',
      top: '58px',
      fontSize: '11px',
      width: '24px',
      height: '24px',
      cursor: 'pointer',
      borderRadius: '50%'
    },
    drawerUserCardText: {
      fontSize: '12px'
    },
    profileTextAreaContainer: {
      paddingRight: '8px'
    },
    profileTextArea: {
      width: '100%',
      background: gray[900],
      height: '100px',
      color: gray[100],
      border: 'none',
      resize: 'none',
      overflow: 'auto',
      fontFamily: 'Lato',
      padding: '8px',
      ':focus': {
        outlineColor: 'transparent',
        outlineStyle: 'none'
      }
    },
    drawerFooter: {
      alignItems: 'center',
      justifyContent: 'flex-end',
      background: gray[700],
      height: '56px',
      width: '100%',
      borderTop: `1px solid ${gray[500]}`,
      // position: 'absolute',
      // top: 'calc(100vh - 56px)',
      flexShrink: '0'
    },
    imageUploaderContainer: {
      position: 'relative',
      maxHeight: '454px'
    },
    imageUploadLoader: {
      position: 'relative',
      height: '454px',
      top: '-400px',
      background: gray[800]
    },
    practiceOwnerRemoveBtn: {
      fontSize: '20px',
      ':hover': {
        color: salmon[500]
      }
    },
    practiceOwnerCard: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '8px',
      background: '#0A3250',
      borderRadius: '5px',
      padding: '8px'
    },
    errMsg: {
      color: '#FF6060',
      fontSize: '12px'
    },
    procLocationCard: {
      height: '40px',
      background: blue[900],
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '8px',
      cursor: 'pointer'
    },
    procIcon: {
      fontSize: '20px',
      ':hover': {
        color: salmon[500]
      }
    }
  });

  // ------------------------------------ Helpers ------------------------------------
  const syncStateToPreviousProps = () => {
    setFacilityDisplayName(displayName);
    setFacilityUserName(userName);
    setOrganization(facilityName);
    setFacilityStreetAddress(streetAddress1);
    setFacilitySuite(suite);
    setFacilityState(state);
    setFacilityCity(city);
    setFacilityZip(zip);
    setFacilityPhone(phone);
    setFacilityFax(fax);
    setFacilityWebsite(website);
    setFacilityProfileDescription(profileDescription);
    setFacilityAvatarImageUrl(avatarImageUrl);
    setFacilityBannerImageUrl(bannerImageUrl);
    setFacilityUsersSearchResults([]);
    setFacilityUsers(props.facilityData.users);
  };

  const uploadCroppedBanner = (blob) => {
    const formData = new FormData();
    formData.append('file', blob, 'croppedBanner.png');
    const options = { method: 'POST', body: formData, redirect: 'follow' };

    fetch(`${BASE_URL}/users/uploadImg`, options)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        // console.log(res);
        if (res.success) {
          // console.log('Cropped banner image url', res.fileUrl);
          setFacilityBannerImageUrl(res.fileUrl);
        }
      })
      .catch(error => console.log('error', error));
  };

  const uploadCroppedAvatar = (blob) => {
    const formData = new FormData();
    formData.append('file', blob, 'croppedAvatar.png');
    const options = { method: 'POST', body: formData, redirect: 'follow' };

    fetch(`${BASE_URL}/users/uploadImg`, options)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        // console.log(res);
        if (res.success) {
          // console.log('Cropped banner image url', res.fileUrl);
          setFacilityAvatarImageUrl(res.fileUrl);
        }
      })
      .catch(error => console.log('error', error));
  };

  // ------------------------------------ Handlers ------------------------------------
  const handleOnClickEditProfile = () => {
    syncStateToPreviousProps();
    toggleEditProfileDrawer(!isEditProfileDrawerOpen);
  };

  const resetState = () => {
    syncStateToPreviousProps();
    setActiveTab(0);
    setFacilityUser('');
    toggleFacilityUserSearchMenu(false);
    setCanAddFacilityUser(false);
    setFacilityUsersSearchResults([]);
    setFacilityUserNpi('');
    setFacilityUserId('');
    setFacilityUserAvatarImageUrl('');
    setFacilityUsers(users);
    toggleBannerCropperDrawer(false);
    setShowBannerCropper(false);
    setIsBannerUploading(false);
    toggleAvatarCropperDrawer(false);
    setShowAvatarCropper(false);
    setIsAvatarUploading(false);
  };

  const closeEditProfileDrawer = () => {
    toggleEditProfileDrawer(false);
    resetState();
  };

  // --- Save Facility Profile ---
  const handleOnClickSaveFacilityProfile = () => {
    const deletedUsers = [];
    users.forEach(el => {
      if (facilityUsers.findIndex(item => item.user === el.user) < 0) {
        deletedUsers.push(el);
      }
    });

    const myHeaders = new Headers();
    const token = localStorage.getItem('token');
    myHeaders.append('Authorization', `Bearer ${token}`);

    const formData = new FormData();
    formData.append('facilityId', props.facilityData._id);
    formData.append('displayName', facilityDisplayName);
    formData.append('userName', facilityUserName);
    formData.append('organization', organization);
    formData.append('streetAddress', facilityStreetAddress);
    formData.append('suite', facilitySuite);
    formData.append('city', facilityCity);
    formData.append('state', facilityState);
    formData.append('zip', facilityZip);
    formData.append('phone', facilityPhone);
    formData.append('fax', facilityFax);
    formData.append('website', facilityWebsite);
    formData.append('profileDescription', facilityProfileDescription);
    formData.append('facilityUsers', JSON.stringify(facilityUsers));
    formData.append('deletedUsers', JSON.stringify(deletedUsers));
    formData.append('bannerImageUrl', facilityBannerImageUrl);
    formData.append('avatarImageUrl', facilityAvatarImageUrl);

    const requestOptions = {
      method: 'PUT',
      headers: myHeaders,
      body: formData,
      redirect: 'follow'
    };

    fetch(`${BASE_URL}/facility/update`, requestOptions)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        if (res.success) {
          closeEditProfileDrawer();
          props.reloadFacilityData();
        }
      })
      .catch(error => console.log('error', error));
  };

  const handleOnEditDisplayName = (e) => {
    const { value } = e.target;
    setFacilityDisplayNamePristineState(false);
    checkFacilityDisplayNameValidity(value.length >= 2 && value.length <= 40);
    setFacilityDisplayName(value);
  };

  const handleOnEditUserName = (e) => {
    const { value } = e.target;
    setFacilityUserNamePristineState(false);
    checkFacilityUserNameValidity(value.length >= 2 && value.length <= 20 && value.indexOf(' ') < 0);
    setFacilityUserName(value);
  };

  const handleOnEditOrganization = (e) => {
    const { value } = e.target;
    setOrganization(value);
  };

  const handleOnEditStreetAddress = (e) => {
    const { value } = e.target;
    setFacilityStreetAddress(value);
  };

  const handleOnEditSuite = (e) => {
    const { value } = e.target;
    setFacilitySuite(value);
  };

  const handleOnEditCity = (e) => {
    const { value } = e.target;
    setFacilityCity(value);
  };

  const handleOnEditState = (e) => {
    const { value } = e.target;
    setFacilityState(value);
  };

  const handleOnEditZip = (e) => {
    const { value } = e.target;
    setFacilityZip(value);
  };

  const handleOnEditPhone = (e) => {
    const { value } = e.target;
    setFacilityPhonePristineState(false);
    checkFacilityPhoneValidity(isMobilePhone(value, 'en-US'));
    setFacilityPhone(value);
  };

  const handleOnEditFax = (e) => {
    const { value } = e.target;
    setFacilityFax(value);
  };

  const handleOnEditWesbite = (e) => {
    const { value } = e.target;
    setFacilityWebsite(value);
  };

  const handleOnChangeProfileDescription = (e) => {
    const { value } = e.target;
    setFacilityProfileDescription(value);
  };

  // Facility User tab handlers
  const handleOnEditFacilityUser = (e) => {
    const { value } = e.target;
    setFacilityUser(value);
  };

  const closeFacilityUserSearchMenu = () => {
    toggleFacilityUserSearchMenu(false);
  };

  const handleOnClickAddFacilityUser = () => {
    if (!canAddFacilityUser) {
      return;
    }

    const updatedFacilityUsers = facilityUsers.concat();
    updatedFacilityUsers.push({
      fullName: facilityUser,
      npi: facilityUserNpi,
      id: facilityUserId,
      accessType: 'Facility User',
      avatarImageUrl: facilityUserAvatarImageUrl
    });

    setFacilityUsers(updatedFacilityUsers);
    setFacilityUser('');
    setFacilityUsersSearchResults([]);
    setCanAddFacilityUser(false);
    toggleFacilityUserSearchMenu(false);
  };

  const removeFacilityUser = (userId) => {
    const updatedFacilityUsers = facilityUsers.filter(el => {
      if (el.user) {
        return el.user !== userId;
      } else {
        return el.id !== userId;
      }
    });
    setFacilityUsers(updatedFacilityUsers);
  };

  const updateAccessType = (accessType, userId) => {
    const updatedFacilityUsers = facilityUsers.concat();
    updatedFacilityUsers.forEach((el) => {
      if (el.user === userId || el.id === userId) {
        el.accessType = accessType;
      }
    });

    setFacilityUsers(updatedFacilityUsers);
  };

  // Banner cropper drawer handlers
  const handleOnBannerFileDrop = (img) => {
    const formData = new FormData();
    formData.append('file', img);
    const options = { method: 'POST', body: formData, redirect: 'follow' };
    setIsBannerUploading(true);
    fetch(`${BASE_URL}/users/uploadImg`, options)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        // console.log(res);
        if (res.success) {
          setFacilityBannerImageUrl(res.fileUrl);
          setIsBannerUploading(false);
          setShowBannerCropper(true);
        }
      })
      .catch(error => console.log('error', error));
  };

  const uploadBanner = () => {
    const formData = new FormData();
    const img = bannerFileInputRef.current.files[0];
    formData.append('file', img);
    const options = { method: 'POST', body: formData, redirect: 'follow' };

    fetch(`${BASE_URL}/users/uploadImg`, options)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        console.log(res);
        if (res.success) {
          setFacilityBannerImageUrl(res.fileUrl);
          setIsBannerUploading(false);
          setShowBannerCropper(true);
        }
      })
      .catch(error => console.log('error', error));
  };

  const handleOnBannerFileSelected = () => {
    if (bannerFileInputRef.current.files.length > 0) {
      setIsBannerUploading(true);
      uploadBanner();
    } else {
      console.log('No file is selected!');
    }
  };

  const handleOnClickBannerCrop = () => {
    const imageElement = bannerCropperRef.current;
    const { cropper } = imageElement;
    cropper.getCroppedCanvas().toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      drawerBannerRef.current.src = url;
      uploadCroppedBanner(blob);
      toggleBannerCropperDrawer(false);
    });
  };

  // Avatar cropper drawer handlers
  const handleOnAvatarFileDrop = (img) => {
    const formData = new FormData();
    formData.append('file', img);
    const options = { method: 'POST', body: formData, redirect: 'follow' };
    setIsAvatarUploading(true);
    fetch(`${BASE_URL}/users/uploadImg`, options)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        // console.log(res);
        if (res.success) {
          setFacilityAvatarImageUrl(res.fileUrl);
          setIsAvatarUploading(false);
          setShowAvatarCropper(true);
        }
      })
      .catch(error => console.log('error', error));
  };

  const uploadAvatar = () => {
    const formData = new FormData();
    const img = avatarFileInputRef.current.files[0];
    formData.append('file', img);
    const options = { method: 'POST', body: formData, redirect: 'follow' };

    fetch(`${BASE_URL}/users/uploadImg`, options)
      .then(response => response.text())
      .then(result => {
        const res = JSON.parse(result);
        console.log(res);
        if (res.success) {
          setFacilityAvatarImageUrl(res.fileUrl);
          setIsAvatarUploading(false);
          setShowAvatarCropper(true);
        }
      })
      .catch(error => console.log('error', error));
  };

  const handleOnAvatarFileSelected = () => {
    if (avatarFileInputRef.current.files.length > 0) {
      setIsAvatarUploading(true);
      uploadAvatar();
    } else {
      console.log('No file is selected!');
    }
  };

  const handleOnClickAvatarCrop = () => {
    const imageElement = avatarCropperRef.current;
    const { cropper } = imageElement;
    cropper.getCroppedCanvas().toBlob((blob) => {
      const url = URL.createObjectURL(blob);
      drawerAvatarRef.current.src = url;
      uploadCroppedAvatar(blob);
      toggleAvatarCropperDrawer(false);
    });
  };

  // #region * Procedure Locations ** event handlers
  const handleOnAddLocation = () => {
    const addLocations = (npl) => {
      const duplicateIdx = procedureLocations.findIndex(el => (
        el.toLowerCase().replace(/ /g, '') === npl.toLowerCase().replace(/ /g, '')
      ));
      if (duplicateIdx < 0) {
        const lastLocation = npl;
        setIsLocDataUpdated(true);
        setProcedureLocations((prvState) => {
          return prvState.concat(lastLocation);
        });
        setTimeout(() => {
          if (locContainerRef.current) {
            locContainerRef.current.scrollTo(0, locContainerRef.current.scrollHeight + 50);
          }
        }, 500);
      } else {
        setNewProcedureLocation('');
        setShowDuplicateLocationMsg(true);
        setTimeout(() => {
          setShowDuplicateLocationMsg(false);
        }, 4000);
      }
    };

    const newProcedureLocationParts = newProcedureLocation.trim().split(',');
    const locSet = new Set();
    newProcedureLocationParts.forEach(el => {
      locSet.add(el.trim().toLowerCase());
    });

    if (locSet.size === 1) {
      // addLocations(newProcedureLocation.trim());
      addLocations(newProcedureLocationParts[0].trim());
      if (locContainerRef.current) {
        locContainerRef.current.scrollTo(0, locContainerRef.current.scrollHeight + 50);
      }
    } else if (locSet.size > 1 && Array.isArray(newProcedureLocationParts) && newProcedureLocationParts.length > 1) {
      newProcedureLocationParts.forEach(el => {
        addLocations(el.trim());
      });
    } else {
      addLocations(newProcedureLocation.trim());
      if (locContainerRef.current) {
        locContainerRef.current.scrollTo(0, locContainerRef.current.scrollHeight + 50);
      }
    }

    setNewProcedureLocation('');
  };

  const handleOnDeleteLocation = (loc) => {
    setLocationToDelete(loc);
    setShowLocationDeleteWarning(true);
  };

  const handleOnSaveFacilityLocations = async () => {
    const formData = new FormData();
    formData.append('facilityId', props.facilityData._id);
    formData.append('locations', JSON.stringify(procedureLocations));
    // Request Headers incl Authorization
    const reqHeaders = new Headers();
    const token = localStorage.getItem('token');
    reqHeaders.append('Authorization', `Bearer ${token}`);
    const requestOptions = {
      method: 'POST',
      body: formData,
      redirect: 'follow',
      headers: reqHeaders
    };
    const response = await fetch(`${BASE_URL}/facility/updateFacilityLocations`, requestOptions);
    const result = await response.json();

    if (result.success) {
      props.reloadFacilityData();
    }
    setShowManageLocationsDrawer(false);
  };
  // #endregion

  // ----------------------------------- Menu Items -----------------------------------
  // Facility Users search results
  const facUsers = [];
  if (facilityUsersSearchResults.length > 0) {
    facilityUsersSearchResults.forEach(el => {
      facUsers.push(
        <div
          className='m-item'
          style={{
            height: '50px',
            display: 'flex',
            alignItems: 'center',
            borderBottom: '1px solid #001824',
            cursor: 'pointer',
            fontSize: '12px',
            background: gray[700]
          }}
          onClick={() => {
            setFacilityUser(`${el.lastName}, ${el.firstName}`);
            setFacilityUserNpi(el.npi ? el.npi : 'NPI n/a');
            setFacilityUserId(el._id);
            setFacilityUserAvatarImageUrl(el.avatarImageUrl);
            toggleFacilityUserSearchMenu(false);
            setCanAddFacilityUser(true);
          }}
        >
          <div>
            {`${el.lastName}, ${el.firstName} (${el.npi ? el.npi : 'NPI n/a'})`}
          </div>
        </div>
      );
    });
  }

  const addedFacilityUsers = [];
  if (Array.isArray(facilityUsers) && facilityUsers.length > 0) {
    facilityUsers.forEach(el => {
      addedFacilityUsers.push(
        <PracticeUserCard
          el={el}
          removePracticeOwner={removeFacilityUser}
          updateAccessType={updateAccessType}
        />
      );
    });
  }

  // ---------------------------- Edit profile drawer tabs ----------------------------
  const facilityInfoTab = (
    <div className='p-1'>
      {/* Banner */}
      <div className={css(styles.drawerBanner)}>
        <img
          ref={drawerBannerRef}
          src={facilityBannerImageUrl}
          alt="cropped-banner"
          className={css(styles.drawerBannerImg)}
        />
        {/* Camera icon */}
        <div
          onClick={() => { toggleBannerCropperDrawer(true); }}
          className={css(styles.drawerBannerCameraIcon)}
        >
          <i className="fa fa-camera" />
        </div>
      </div>
      {/* Middle area */}
      <div className={css(styles.drawerContentArea)}>
        {/* User card */}
        <div className="fx ml-2">
          {/* Avatar */}
          <div className={css(styles.drawerUserCardAvatar)}>
            <img
              src={facilityAvatarImageUrl}
              ref={drawerAvatarRef}
              alt="avatar"
              className={css(styles.drawerUserCardAvatarImg)}
              onClick={() => toggleAvatarCropperDrawer(true)}
            />
            <div
              onClick={() => { toggleAvatarCropperDrawer(true); }}
              className={css(styles.drawerAvatarCamera)}
            >
              <i className="fa fa-camera" />
            </div>
          </div>
          {/* User card displayName & userName */}
          <div className={`ml-2 ${css(styles.drawerUserCardText)}`}>
            {/* Name and Npi */}
            <div style={{ fontSize: '12px', color: gray[200], lineHeight: '12px', paddingLeft: '2px' }}>
              {/* {`${facilityName !== '' ? titleCase(facilityName) : ''} (NPI: ${npi})`} */}
              {`${facilityName !== '' ? facilityName : ''} (NPI: ${npi})`}
            </div>
            {/* Display Name */}
            <div className='mt-2'>
              <TextInputWithLabel
                value={facilityDisplayName}
                titleText="Display Name (2 to 40 characters)*"
                titleFontSize={12}
                titleColor={gray[200]}
                textColor="white"
                selectionColor="white"
                selectionBackground="#0080FF"
                spellcheck={false}
                width={248}
                onChange={handleOnEditDisplayName}
              />
              {/* Error message */}
              {!isFacilityDisplayNameValid && !isFacilityDisplayNamePristine
                ? <div
                  style={{
                    color: '#FF6060',
                    fontSize: '12px'
                  }}
                >
                  Invalid Display Name
                </div>
                : null
              }
            </div>
            {/* UserName */}
            <div
              style={{
                marginTop: (!isFacilityDisplayNameValid && !isFacilityDisplayNamePristine) ? '0px' : '4px'
              }}
            >
              <TextInputWithLabel
                value={facilityUserName}
                titleText="Username (2 to 20 characters, no spaces)"
                titleFontSize={12}
                isCompactLayout={true}
                titleColor={gray[200]}
                textColor={blue[500]}
                selectionColor="white"
                selectionBackground="#0080FF"
                spellcheck={false}
                width={248}
                onChange={handleOnEditUserName}
              />
              {/* Error message */}
              {!isFacilityUserNameValid && !isFacilityUserNamePristine
                ? <div
                  style={{
                    color: '#FF6060',
                    fontSize: '12px'
                  }}
                >
                  Invalid User Name
                </div>
                : null
              }
              {isFacilityUserNameValid && !isFacilityUserNamePristine && isDuplicateUserName &&
                <div style={{ color: '#FF6060', fontSize: '12px' }}>
                  User Name Taken
                </div>
              }
            </div>
          </div>
        </div>
        {/* Middle area */}
        <div className="mt-4 ml-2">
          {/* Mailing address heading */}
          <div className="fx fx__v-center">
            <i className="fa fa-map-marker" style={{ fontSize: '28px' }} />
            <div className="ml-2">
              Mailing Address
            </div>
          </div>
          {/* Form */}
          <div>
            {/* Organization */}
            <div>
              <TextInputWithLabel
                value={organization}
                titleText="Organization"
                titleFontSize={12}
                isCompactLayout={true}
                titleColor={gray[200]}
                textColor="white"
                selectionColor="white"
                selectionBackground="#0080FF"
                spellcheck={false}
                width={337}
                onChange={handleOnEditOrganization}
              />
            </div>
            {/* Street address & suite */}
            <div className="fx">
              <div>
                <TextInputWithLabel
                  value={facilityStreetAddress}
                  titleText="Street"
                  titleFontSize={12}
                  isCompactLayout={true}
                  titleColor={gray[200]}
                  textColor="white"
                  selectionColor="white"
                  selectionBackground="#0080FF"
                  spellcheck={false}
                  width={284}
                  onChange={handleOnEditStreetAddress}
                />
              </div>
              <div className="ml-2">
                <TextInputWithLabel
                  value={facilitySuite}
                  titleText="Suite"
                  titleFontSize={12}
                  isCompactLayout={true}
                  titleColor={gray[200]}
                  textColor="white"
                  selectionColor="white"
                  selectionBackground="#0080FF"
                  spellcheck={false}
                  width={45}
                  onChange={handleOnEditSuite}
                />
              </div>
            </div>
            {/* City, State and Zip */}
            <div className="fx mt-2">
              <div>
                <TextInputWithLabel
                  value={facilityCity}
                  titleText="City"
                  titleFontSize={12}
                  isCompactLayout={true}
                  titleColor={gray[200]}
                  textColor="white"
                  selectionColor="white"
                  selectionBackground="#0080FF"
                  spellcheck={false}
                  width={230}
                  onChange={handleOnEditCity}
                />
              </div>
              <div className="ml-2">
                <TextInputWithLabel
                  value={facilityState}
                  titleText="State"
                  titleFontSize={12}
                  isCompactLayout={true}
                  titleColor={gray[200]}
                  textColor="white"
                  selectionColor="white"
                  selectionBackground="#0080FF"
                  spellcheck={false}
                  width={45}
                  onChange={handleOnEditState}
                />
              </div>
              <div className="ml-2">
                <TextInputWithLabel
                  value={facilityZip}
                  titleText="Zip"
                  titleFontSize={12}
                  isCompactLayout={true}
                  titleColor={gray[200]}
                  textColor="white"
                  selectionColor="white"
                  selectionBackground="#0080FF"
                  spellcheck={false}
                  width={45}
                  onChange={handleOnEditZip}
                />
              </div>
            </div>
            {/* Email - message */}
            <div
              className='mt-4 fx fx__v-center'
              style={{ color: gray[200] }}
            >
              <i className='fa fa-lg fa-envelope mr-2' />
              <div style={{ fontSize: '12px' }}>
                <div>
                  Email&nbsp;
                  <span>
                    {/* (Go to <span style={{ color: blue[500] }}>Login Credentials</span> to edit) */}
                    (Go to <Link to='/settings/loginCredentials' style={{ color: blue[500] }}>Login Credentials</Link> to edit)
                  </span>
                </div>
                <div>{email}</div>
              </div>
            </div>
            {/* Phone */}
            <div className="mt-2">
              <TextInputWithLabel
                value={facilityPhone}
                titleText="Phone"
                titleFontSize={12}
                isCompactLayout={false}
                titleColor={gray[200]}
                textColor="white"
                selectionColor="white"
                selectionBackground="#0080FF"
                spellcheck={false}
                width={337}
                showPreIcon
                preIcon='fa fa-phone'
                onChange={handleOnEditPhone}
              />
              {!isFacilityPhonePristine && !isFacilityPhoneValid
                ? <div className={css(styles.errMsg)}>Invalid Phone #</div>
                : null
              }
            </div>
            {/* Fax */}
            <div className="mt-2">
              <TextInputWithLabel
                value={facilityFax}
                titleText="Fax"
                titleFontSize={12}
                isCompactLayout={false}
                titleColor={gray[200]}
                textColor="white"
                selectionColor="white"
                selectionBackground="#0080FF"
                spellcheck={false}
                width={337}
                showPreIcon
                preIcon='fa fa-fax'
                onChange={handleOnEditFax}
              />
            </div>
            {/* Website */}
            <div className="mt-2">
              <TextInputWithLabel
                value={facilityWebsite}
                titleText="Website"
                titleFontSize={12}
                isCompactLayout={false}
                titleColor={gray[200]}
                textColor="white"
                selectionColor="white"
                selectionBackground="#0080FF"
                spellcheck={false}
                width={337}
                showPreIcon
                preIcon='fa fa-globe'
                onChange={handleOnEditWesbite}
              />
            </div>
          </div>
        </div>
        {/* Profile descriptiom */}
        <div className="mt-4 ml-2">
          <div>Profile Description</div>
          <div className={css(styles.profileTextAreaContainer)}>
            <textarea
              className={css(styles.profileTextArea)}
              placeholder="Write a description"
              value={facilityProfileDescription}
              onChange={handleOnChangeProfileDescription}
            />
          </div>
        </div>
      </div>
    </div>
  );

  const facilityUsersTab = (
    <div className='p-1'>
      <div className='pl-2 pr-2'>
        <div
          className='mt-3 fx'
          ref={facilityUsersRef}
        >
          <div>
            <TextInputWithLabel
              value={facilityUser}
              titleText="Add Facility User"
              isCompactLayout={false}
              showPreIcon
              preIcon='fa fa-user-plus'
              titleColor="#60A0E0"
              textColor="#0080FF"
              selectionColor="white"
              selectionBackground="#0080FF"
              spellcheck={false}
              width={280}
              onChange={handleOnEditFacilityUser}
              onClick={() => {
                toggleFacilityUserSearchMenu(true);
              }}
            />
            <PopupMenu
              top={145}
              left={16}
              zIndex='1550'
              position="absolute"
              visible={showFacilityUserSearchMenu}
              parent={facilityUsersRef}
              onOutsideClick={closeFacilityUserSearchMenu}
            >
              <div style={{ background: '#0a3250', width: '328px' }}>
                {facilityUsersSearchResults.length === 0
                  ? <div
                    className='fx fx__hv-center'
                    style={{ height: '40px' }}
                  >
                    Search Facility Users
                  </div>
                  : null
                }
                {facUsers}
              </div>
            </PopupMenu>
          </div>
          {/* Add practice owner button */}
          <Button
            btnType='primary'
            isDisabled={!canAddFacilityUser}
            style={{
              maxWidth: '48px',
              minWidth: '48px',
              maxHeight: '24px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              marginTop: '14px',
              fontSize: '14px'
            }}
            onClick={handleOnClickAddFacilityUser}
          >
            Add
          </Button>
        </div>
        <div className='mt-2 pl-2 pr-2'>
          {addedFacilityUsers}
        </div>
      </div>
    </div>
  );

  return (
    <div className='p-2'>
      {showDuplicateLocationMsg &&
        <Toast
          id={'c1'}
          top="41"
          bottom={null}
          headerText='Information'
          headerIcon='fa fa-info-circle'
          bodyText='Duplicate Location!'
          onDismiss={() => {
            setShowDuplicateLocationMsg(false);
          }}
          showFooter={false}
        />
      }
      {/* Edit profile drawer */}
      {isEditProfileDrawerOpen &&
        <Drawer
          placement="right"
          visible={isEditProfileDrawerOpen}
          toggleDrawer={closeEditProfileDrawer}
          zIndex="2000"
          width={window.innerWidth <= 700 ? window.innerWidth : 358}
        >
          <div className={css(styles.drawerContainer)}>
            {/* Header */}
            <div className={css(styles.drawerHeader)}>
              <div className='fx fx__hv-center'>
                <i className='mr-2 fa fa-lg fa-building-o' />
                <div>Edit Profile</div>
              </div>
              <i
                className={`fa fa-lg fa-times-circle ${css(styles.drawerHeaderCloseIcon)}`}
                onClick={closeEditProfileDrawer}
              />
            </div>
            {/* Active tab */}
            <div className={css(styles.drawerContentArea)}>
              {facilityInfoTab}
            </div>
            {/* Footer */}
            <div className={`fx pr-2 ${css(styles.drawerFooter)}`} >
              <Button
                btnType="primary"
                isDisabled={!canSaveFacility}
                className="fx fx__hv-center"
                onClick={handleOnClickSaveFacilityProfile}
                style={{
                  height: '32px',
                  width: '340px',
                  padding: '3px 0'
                }}
              >
                Save Facility Profile
              </Button>
            </div>
          </div>
        </Drawer>
      }
      {/* Banner cropper drawer */}
      {isBannerCropperDrawerOpen
        ? <Drawer
          placement="right"
          visible={isBannerCropperDrawerOpen}
          toggleDrawer={() => toggleBannerCropperDrawer(false)}
          zIndex="2050"
          width={window.innerWidth <= 700 ? window.innerWidth : 358}
        >
          <div className={css(styles.drawerContainer)}>
            {/* Header */}
            <div className={css(styles.drawerHeader)}>
              <div>Upload Profile Banner</div>
              <i
                className={`fa fa-times-circle ${css(styles.drawerHeaderCloseIcon)}`}
                onClick={() => { toggleBannerCropperDrawer(false); }}
              />
            </div>
            {/* Content Area */}
            <div className={css(styles.drawerContentArea, styles.imageUploaderContainer)}>
              {showBannerCropper
                ? <div>
                  <Cropper
                    src={facilityBannerImageUrl}
                    style={{ height: 400, width: '100%' }}
                    checkCrossOrigin
                    checkOrientation={false}
                    aspectRatio={6}
                    background={false}
                    viewMode={1}
                    autoCropArea={1}
                    guides={false}
                    ref={bannerCropperRef}
                  />
                </div>
                : null
              }
              {!showBannerCropper
                ? <div>
                  <FileUploader
                    parentRef={bannerFileInputRef}
                    onDrop={handleOnBannerFileDrop}
                    onChange={handleOnBannerFileSelected}
                  />
                </div>
                : null
              }
              {isBannerUploading
                ? <div className={css(styles.imageUploadLoader)}>
                  <Loader iconType="cog" iconSize="5x" text="Uploading Banner Image" />
                </div>
                : null
              }
            </div>
            {/* Drawer footer area */}
            <div
              className={`fx pr-2 ${css(styles.drawerFooter)}`}
              style={{ position: 'absolute', bottom: '0' }}
            >
              <Button
                btnType="primary"
                className="fx fx__hv-center"
                onClick={handleOnClickBannerCrop}
                style={{
                  height: '32px',
                  width: '340px',
                  padding: '3px 0'
                }}
              >
                Crop Banner Image
              </Button>
            </div>
          </div>
        </Drawer>
        : null
      }
      {/* Avatar cropper drawer */}
      {isAvatarCropperDrawerOpen
        ? <Drawer
          placement="right"
          visible={isAvatarCropperDrawerOpen}
          toggleDrawer={() => toggleAvatarCropperDrawer(false)}
          zIndex="2050"
          width={window.innerWidth <= 700 ? window.innerWidth : 358}
        >
          <div className={css(styles.drawerContainer)}>
            {/* Header */}
            <div className={css(styles.drawerHeader)}>
              <div>Upload Profile Avatar</div>
              <i
                className={`fa fa-times-circle ${css(styles.drawerHeaderCloseIcon)}`}
                onClick={() => { toggleAvatarCropperDrawer(false); }}
              />
            </div>
            {/* Content area */}
            <div className={css(styles.drawerContentArea, styles.imageUploaderContainer)}>
              {showAvatarCropper
                ? <div>
                  <Cropper
                    src={facilityAvatarImageUrl}
                    style={{ height: 400, width: '100%' }}
                    checkCrossOrigin
                    checkOrientation={false}
                    aspectRatio={1}
                    background={false}
                    viewMode={1}
                    autoCropArea={1}
                    guides={false}
                    ref={avatarCropperRef}
                  />
                </div>
                : null
              }
              {!showAvatarCropper
                ? <div>
                  <FileUploader
                    parentRef={avatarFileInputRef}
                    onDrop={handleOnAvatarFileDrop}
                    onChange={handleOnAvatarFileSelected}
                  />
                </div>
                : null
              }
              {isAvatarUploading
                ? <div className={css(styles.imageUploadLoader)}>
                  <Loader iconType="cog" iconSize="5x" text="Uploading Avatar Image" />
                </div>
                : null
              }
            </div>
            {/* Drawer footer */}
            <div
              className={`fx pr-2 ${css(styles.drawerFooter)}`}
              style={{ position: 'absolute', bottom: '0' }}
            >
              <Button
                btnType="primary"
                className="fx fx__hv-center"
                onClick={handleOnClickAvatarCrop}
                style={{
                  height: '32px',
                  width: '340px',
                  padding: '3px 0'
                }}
              >
                Crop Avatar Image
              </Button>
            </div>
          </div>
        </Drawer>
        : null
      }

      {/* Location Delete Warning Dialog */}
      {showLocationDeleteWarning &&
        <WarningDialog
          show={showLocationDeleteWarning}
          title='Delete Location'
          message={`Do you want to delete ${locationToDelete} location?`}
          onCancel={() => setShowLocationDeleteWarning(false)}
          onContinue={() => {
            setShowLocationDeleteWarning(false);
            setIsLocDataUpdated(true);
            setProcedureLocations((prvState) => (prvState.filter(el => el !== locationToDelete)));
          }}
        />
      }

      { /* Save Locations Working Dialog */ }
      {showSaveWarningMessage &&
        <WarningDialog
          show={showSaveWarningMessage}
          title='Close Without Saving'
          message={`Close facility location drawer without saving changes?`}
          onCancel={() => setShowSaveWarningMessage(false)}
          onContinue={() => {
            setShowSaveWarningMessage(false);
            setShowManageLocationsDrawer(false);
          }}
        />
      }

      {/* Manage Locations drawer */}
      {showManageLocationsDrawer &&
        <Drawer
          disableMaskClick
          placement="right"
          visible={showManageLocationsDrawer}
          toggleDrawer={() => setShowManageLocationsDrawer(false)}
          zIndex="2050"
          width={window.innerWidth <= 700 ? window.innerWidth : 358}
        >
          <div className={css(styles.drawerContainer)}>
            {/* Header */}
            <div className={css(styles.drawerHeader)}>
              <div>Manage Procedure Locations</div>
              <i
                className={`fa fa-times-circle ${css(styles.drawerHeaderCloseIcon)}`}
                onClick={() => {
                  if (isLocDataUpdated) {
                    setShowSaveWarningMessage(true);
                  } else {
                    setShowManageLocationsDrawer(false);
                  }
                }}
              />
            </div>
            {/* Content */}
            <div
              className={`p-2 ${css(styles.drawerContentArea)}`}
              style={{ display: 'flex', flexFlow: 'column', overflow: 'hidden', marginBottom: '8px' }}
            >
              {/* Add New Location Controls */}
              <div
                style={{ borderBottom: '1px solid black', paddingBottom: '8px' }}
              >
                <div>
                  <TextInput
                    value={newProcedureLocation}
                    placeholder="Add Procedure Location"
                    style={{
                      width: '265px',
                      fontSize: '14px',
                      padding: '0 4px',
                      color: blue[200],
                      borderRadius: '4px'
                    }}
                    onChange={(e) => {
                      const { value } = e.target;
                      setNewProcedureLocation(value);
                    }}
                  />
                  <Button
                    btnType="primary"
                    className="fx fx__hv-center ml-2"
                    isDisabled={newProcedureLocation.length === 0}
                    onClick={handleOnAddLocation}
                    style={{
                      height: '32px',
                      width: '67px',
                      padding: '3px 0'
                    }}
                  >
                    Add
                  </Button>
                </div>
                <div className='mt-2'>
                  <TextInput
                    value={locFilter}
                    showClearFieldIcon
                    placeholder="Filter Location"
                    style={{
                      width: '340px',
                      fontSize: '14px',
                      padding: '0 4px',
                      color: blue[200],
                      borderRadius: '4px'
                    }}
                    onChange={(e) => {
                      const { value } = e.target;
                      setLocFilter(value);
                    }}
                  />
                </div>
              </div>

              {/* Added Locations */}
              <div
                className='mt-2'
                ref={locContainerRef}
                style={{ flexGrow: 1, overflow: 'auto' }}
              >
                <ReactSortable
                  list={procedureLocations}
                  setList={setProcedureLocations}
                  group='foo'
                  animation='100'
                  ghostClass='ghost'
                >
                  {procedureLocations
                    .filter(el => new RegExp(locFilter, 'i').test(el))
                    .map((location) => (
                      <div
                        className={`mt-2 ${css(styles.procLocationCard)}`}
                        key={location}
                      >
                        {location}
                        <i
                          className={`fa fa-trash ${css(styles.procIcon)}`}
                          onClick={() => handleOnDeleteLocation(location)}
                        />
                      </div>
                    ))
                  }
                </ReactSortable>
                {/* Bottom Spacer */}
                <div style={{ height: '100px' }} />
              </div>
            </div>
            {/* Drawer footer */}
            <div
              className={`fx pr-2 ${css(styles.drawerFooter)}`}
              style={{ position: 'absolute', bottom: '0' }}
            >
              {/* Cancel Button */}
              <Button
                btnType="primary"
                isOutlineBtn
                className="fx fx__hv-center mr-2"
                onClick={() => {
                  if (isLocDataUpdated) {
                    setShowSaveWarningMessage(true);
                  } else {
                    setShowManageLocationsDrawer(false);
                  }
                }}
                style={{
                  height: '32px',
                  width: '111px',
                  padding: '3px 0'
                }}
              >
                Cancel
              </Button>
              {/* Save Button */}
              <Button
                btnType="primary"
                className="fx fx__hv-center"
                isDisabled={!isLocDataUpdated}
                onClick={handleOnSaveFacilityLocations}
                style={{
                  height: '32px',
                  width: '111px',
                  padding: '3px 0'
                }}
              >
                Save
              </Button>
            </div>
          </div>
        </Drawer>
      }

      {/* Profile banner */}
      <div className={css(styles.profileBanner)}>
        <img
          className={css(styles.profileBannerImg)}
          src={bannerImageUrl}
          alt='Facility banner'
        />
      </div>
      {/* User card container */}
      <div className={`p-2 ${css(styles.bigUserCardContainer)}`}>
        {/* User card */}
        <div className='fx'>
          <div className={css(styles.userCard)}>
            {!avatarImageUrl
              ? <i className={`fa fa-building-o ${css(styles.userCardIcon)}`} />
              : <img
                className={css(styles.userCardAvatarImg)}
                src={avatarImageUrl}
                alt='Facility avatar'
              />
            }
          </div>
          <div className='ml-2'>
            <div>{displayName}</div>
            <div className={css(styles.userCardDisplayName)}>
              {`@${userName}`}
            </div>
          </div>
        </div>
        {/* Ellipsis menu */}
        <div
          ref={popupRef}
          className={`cursor__pointer ${css(styles.userCardEllipsisMenuBtn)}`}
          onClick={() => toggleEllipsisMenu(!isEllipisiMenuOpen)}
        >
          <i className='fa fa-ellipsis-v' />
          <PopupMenu
            top={28}
            right={-1}
            visible={isEllipisiMenuOpen}
            parent={popupRef}
            position="absolute"
            onOutsideClick={() => toggleEllipsisMenu(false)}
          >
            <div className={css(styles.popupMenuContainer)}>
              <div
                className={`m-item ${css(styles.popupMenuItem)}`}
                onClick={handleOnClickEditProfile}
              >
                <div className={css(styles.menuItemIconContainer)}>
                  <i className={`fa fa-pencil ${css(styles.menuItemIcon)}`} />
                </div>
                <div>Edit Profile</div>
              </div>
              <div
                className={`m-item ${css(styles.popupMenuItem)}`}
                onClick={() => {
                  setNewProcedureLocation('');
                  setProcedureLocations(props.facilityData.locations || []);
                  setShowDuplicateLocationMsg(false);
                  setShowLocationDeleteWarning(false);
                  setLocationToDelete('');
                  setShowSaveWarningMessage(false);
                  setIsLocDataUpdated(false);
                  setShowManageLocationsDrawer(true);
                }}
              >
                <div className={css(styles.menuItemIconContainer)}>
                  <i className={`fa fa-cog ${css(styles.menuItemIcon)}`} />
                </div>
                <div>Manage Locations</div>
              </div>
            </div>
          </PopupMenu>
        </div>
      </div>
      {/* Tabs */}
      <div ref={tabsContainer}>
        <TabsContainer
          dropDownId="d1"
          showPlusIcon={false}
          shiftMethod='availableWidth'
          containerWidth={tabsContainer && tabsContainer.current ? tabsContainer.current.getBoundingClientRect().width : 230}
          otherElementsWidth={320}
          minWidth={230}
          dropDownTop={39}
          dropDownLeft={44}
          dropDownHeaderStyles={{
            minWidth: '170px',
            maxWidth: '370px',
            width: '100%'
          }}
          containerStyles={{
            width: '100%'
          }}
        >
          {/* About Tab */}
          <TabItem
            tabKey="1"
            key='9898'
            parentKey="0111"
            text="About"
            isActive={
              pathname.endsWith('/about') ||
              pathname.endsWith('/profile')
            }
            iconClass='fa fa-info-circle'
            style={{
              paddingRight: '0',
              width: '90px',
              minWidth: '90px',
              maxWidth: '80px'
            }}
            textStyles={tabsTextStyles}
            onActivate={() => {
              history.push(`${url}/about`);
            }}
          >
            <Link
              to={`${url}/about`}
              className={css(
                styles.tabText,
                styles.linkStyles,
                pathname.endsWith('/about') && styles.selectedLink
              )}
            >
              About
            </Link>
          </TabItem>
          {/* Contact  */}
          <TabItem
            tabKey="2"
            key='9899'
            parentKey="0111"
            text="Contact"
            isActive={pathname.endsWith('/contact')}
            iconClass='fa fa-info-circle'
            style={{
              paddingRight: '0',
              width: '100px',
              minWidth: '90px',
              maxWidth: '100px'
            }}
            textStyles={tabsTextStyles}
            onActivate={() => {
              history.push(`${url}/contact`);
            }}
          >
            <Link
              to={`${url}/contact`}
              className={css(
                styles.tabText,
                styles.linkStyles,
                pathname.endsWith('/contact') && styles.selectedLink
              )}
            >
              Contact
            </Link>
          </TabItem>
        </TabsContainer>
        {/* Active tab component */}
        <Switch>
          <Route exact path={path}>
            <About description={profileDescription} />
          </Route>
          <Route path={`${path}/about`}>
            <About description={profileDescription} />
          </Route>
          <Route path={`${path}/contact`}>
            <Contact
              organization={facilityName}
              hideName
              mailingAddress={{
                street: streetAddress1,
                suite,
                city,
                state,
                zip
              }}
              email={email}
              mobile={null}
              phone={phone}
              fax={fax}
              profileDescription={profileDescription}
              website={website}
            />
          </Route>
        </Switch>
      </div>
    </div>
  );
};

export default AboutFacility;
